export default __webpack_public_path__ + "static/media/img-0568-finland-half-face.2d2a5c19.png";